import { z } from "zod";

// t("DOCTOR")
export const memberLicenceType = z.enum(["DOCTOR", "EMPLOYEE"]);
export type MemberLicenceType = z.infer<typeof memberLicenceType>;
